/* eslint-disable */ // TN disabling for hotfix.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Button } from '@missionlabs/smartagent-app-components';

import useContact from 'hooks/redux/useContact';
import useContactLogForm from 'hooks/useContactLogForm';
import useMonitoring from 'hooks/redux/useMonitoring';

import RootState from 'store/state';
import { setShowNextStatus } from 'store/user/user.actions';

import { getRequiredFields, isContactLogEmpty, isAllRequiredFieldsFilled } from 'utils';

import './contact-log.scss';

interface Props extends ReturnType<typeof mapStateToProps> {
    setShowNextStatus: typeof setShowNextStatus;
    onComplete?: () => void;
}

const CompleteWrapUp: React.FC<Props> = props => {
    let contact = useContact();
    const contactLog = useContactLogForm();
    const { contacts } = props;
    const { isEnhancedMonitoringEnabled } = useMonitoring();
    const [acwComplete, setAcwComplete] = useState<boolean>(false);

    if (!contact?.ID && contacts.length) {
        contact = contacts.filter(contact => contact.channel === 'VOICE')[0];
    }

    const acwAttributes = contacts.find(c => c.ID === contact?.ID)?.acwAttributes;

    useEffect(() => {
        const noContactLogOrEmpty = isContactLogEmpty(contactLog);
        // Do not force monitoring voice contacts to complete ACW
        if (noContactLogOrEmpty || isEnhancedMonitoringEnabled) {
            setAcwComplete(true);
            return;
        }
        if (acwAttributes) {
            const requiredFields = getRequiredFields(contactLog, acwAttributes);
            isAllRequiredFieldsFilled(acwAttributes, requiredFields) ? setAcwComplete(true) : setAcwComplete(false);
        }
    }, [contact?.ID, JSON.stringify(acwAttributes)]);

    const submitAcw = () => {
        props.onComplete?.();
    };

    return (
        <div className="acw-complete row between">
            <Button type={'button'} disabled={!acwComplete} elastic curved styling="primary" onClick={submitAcw}>
                Finish wrap up
            </Button>
        </div>
    );
};

function mapStateToProps(state: RootState) {
    const { contacts } = state;
    return {
        contacts,
    };
}

export default connect(mapStateToProps, { setShowNextStatus })(CompleteWrapUp);
